import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'

import { flexCenter } from 'style/emotion'

const CaseLevelHeaderContainer = styled('div')`
  background-color: var(--print-main);
  width: 100%;
`

const CaseLevelHeaderContent = styled('div')`
  ${flexCenter}

  color: white;
  font-size: 1.25rem;
  height: var(--case-nav-bar-height);
  justify-content: flex-start;
  padding-left: 16px;
  padding-right: 16px;

  > * + * {
    margin-left: 8px;
  }

  ${mediaQuery('mobile')} {
    font-size: 1rem;
    padding-left: 8px;
    padding-right: 8px;
  }

  img {
    border-radius: 40px;
    height: 40px;
    width: 40px;
  }
`

const CaseLevelHeaderBtn = styled('div')`
  cursor: default;
  pointer-events: none;

  ${mediaQuery('mobile')} {
    font-size: 1.125rem;
  }
`

const NameContainer = styled('div')`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const LawfirmName = styled('span')`
  ${mediaQuery('', 'mobile')} {
    font-size: 1.125rem;
  }
`

const SmallStatusText = styled('span')`
  font-size: 0.75rem;

  ${mediaQuery('', 'mobile')} {
    display: none;
  }
`

const StatusText = styled('span')`
  flex: 1;
  font-size: 0.75rem;
  text-align: end;

  ${mediaQuery('mobile')} {
    display: none;
  }
`

export {
  CaseLevelHeaderBtn,
  CaseLevelHeaderContainer,
  CaseLevelHeaderContent,
  LawfirmName,
  NameContainer,
  SmallStatusText,
  StatusText
}
